import { Switch, Route } from "react-router-dom";
import { Login } from '../pages/Login'

export function PublicRoutes() {
    return (
        <>
            <Switch>             
                <Route exact path='/' component={Login} />  
                <Route exact path="/login" component={Login} />
                <Route path="/login/:acceso" render={({ match }) => {
                    return <Login acceso={match.params.acceso} />
                }} />
            </Switch>
        </>
    )
}